import { createAction, handleActions } from 'redux-actions'

const setLogo = createAction('MODALS/RAMSSIGNING/SET_LOGO')
const resetLogo = createAction('MODALS/RAMSSIGNING/RESET_LOGO')

const defaultState = null

const reducer = handleActions(
  {
    [setLogo]: (state, { payload }) => payload,
    [resetLogo]: () => defaultState,
  },
  defaultState
);

export { setLogo, resetLogo, reducer }
